<template>
	<div>
		<div class="d-none d-sm-block googleCalendar">
			<iframe src="https://calendar.google.com/calendar/embed?showTitle=0&amp;showPrint=0&amp;showTabs=0&amp;showCalendars=0&amp;showTz=0&amp;height=600&amp;wkst=2&amp;bgcolor=%23FFFFFF&amp;src=2bjvfmu6oug6huab9la4efji2c%40group.calendar.google.com&amp;color=%23182C57&amp;ctz=Europe%2FLondon" style="border-width:0" width="800" height="600" frameborder="0" scrolling="no"></iframe>
		</div>
		<div class="d-block d-sm-none googleCalendar">
            <iframe src="https://calendar.google.com/calendar/embed?showTitle=0&amp;showDate=0&amp;showPrint=0&amp;showTabs=0&amp;showCalendars=0&amp;showTz=0&amp;mode=WEEK&amp;height=1200&amp;wkst=2&amp;bgcolor=%23FFFFFF&amp;src=2bjvfmu6oug6huab9la4efji2c%40group.calendar.google.com&amp;color=%23853104&amp;ctz=Europe%2FLondon" style="border-width:0" width="600" height="1200" frameborder="0" scrolling="no"></iframe>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'calendarcontent-component',
		props: ['contentData', 'index', 'hide', 'dragging', 'authenticated'],
		methods: {

		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.googleCalendar {
		position: relative;
		height: 500px;
		width: 100%;
		padding-bottom: 50%;
	}

	.googleCalendar iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
</style>
